import { TableHead, TableRow } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface StyledTableHeadProps {
  children: ReactNode;
}

export default function StyledTableHead({ children }: StyledTableHeadProps) {
  const theme = useTheme();

  return (
    <TableHead>
      <TableRow
        sx={{
          '& th': {
            color: theme.palette.text.secondary,
            padding: '1em 0 1.5em 0',
            borderBottomWidth: '0',
            textAlign: 'start'
          }
        }}>
        {children}
      </TableRow>
    </TableHead>
  );
}
